<h4 class="animate__animated animate__fadeInDown breadcrumb-wrapper m-0" *ngIf="breadCrumnModel">

    <span class="text-muted fw-light" *ngFor="let item of breadCrumnModel.rootItems">
        {{ item | translate }}
        /
    </span>

    {{ breadCrumnModel.thisPage | translate }}
</h4>